<template>
  <div>
    <div class="photos">
      <div class="top">
        <back-button cssClass="reverse" />
        <help-button cssClass="reverse" />
      </div>
      <tiny-slider ref="slider" class="imageviewer" :mouse-drag="true" :loop="false" :nav="false" :controls="true" :max-zoom="5">

        <div v-for="(photo,index) in galleries" :key="index">
          <div>
            <pinch-image :src="photo.url" :alt="photo.caption" />
            <!-- <img :src="photo.url" :alt="photo.caption" class="inline-image" /> -->
          </div>

          <div class="caption" v-if="showcaption">
            <div v-html="photo.caption" />
          </div>

          <div v-if="photo.caption" class="captioncontrols">
            <button @click="onShowCaption" class="reverse">
              {{ captionbutton }}
            </button>
          </div>
        </div>

      </tiny-slider>
    </div>

  </div>
</template>

<script>

// Be aware 100vh isn't good here...
// https://bugs.webkit.org/show_bug.cgi?id=141832
import TinySlider from 'vue-tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'
import PinchImage from './vendor/PinchImage.vue'

export default {
  name: 'Photos',
  components: {
    'tiny-slider': TinySlider,
    'pinch-image': PinchImage
  },
  props: {
    exhibitslug: String,
    gid: {
      type: Number,
      default: 0
    },
    slide: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showcaption: false
    }
  },
  computed: {
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    },
    captionbutton () {
      return this.showcaption ? 'Hide caption' : 'Show caption'
    },
    galleries () {
      return this.exhibitdata.galleries[this.gid].gallery
    }
  },
  mounted () {
    if (this.galleries.length >= 1) {
      this.$refs.slider.goTo(this.slide)
    }

     console.log(this.$route.params.exhibitslug);
  },
  methods:{


    onShowCaption(e){
      this.showcaption = !this.showcaption
      console.log('onShowCaption', e, this.showcaption)

    }
  }
}
</script>

<style lang="scss">


  $padding:10px;

.photos {
  position:relative;
  color: #000;
  background-color: black;
  flex: 1;
  max-height: 100%;
  height: 100%;

  .top {
    position:absolute;
    width: 100%;
    text-align: center;
    z-index: 1;
    padding: $padding;
    display: flex;
    justify-content: space-between;
  }

  // carousel
  .tns-outer {
    height: 100%;
    //position: relative;
  }

  .tns-ovh{
    max-height:100%;
  }
  .tns-inner {
    //max-height:100%;
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    overflow:hidden;
    // VH is totally wrong on iOS...
    //height: 100vh;
    .tns-carousel {
      height: 100%;
    }
    .tns-item {
      height: 100%;
      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: 100%;
        height: 100%;
      }

      // Actual image inside...
      img {
        // stretch?
        width:100%;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  div.imageviewer {
    max-height:100%;
    height: 100%;

    > div {
      height: 100%;
      position:relative;

      // haha wtf
      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: 100%;
        height: 100%;
        position:relative;
        //overflow:hidden;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }

      // bottom caption button
      div.captioncontrols {
        position:absolute;
        bottom:$padding;
        left:30px + $padding;
        right:30px + $padding;
        display: block;
        height: auto;
        text-align: center;
        z-index: 3;
        outline: none;

        // Show Caption button
        button{
          padding:$padding;
          cursor: pointer;
        }
      }

      div.caption {
        position: absolute;
        left: 0;
        color: white;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        padding: 0 30px;
        right: 0;
        bottom: 0px;
        // position:absolute;
        // top: 0;
        // left: 0;
        // color: white;
        // height: 100%;
        // width: 100%;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // // background: rgba(0, 0, 0, 0.7);
        // flex: 1;
        // padding:0 30px;
         > div {
            position: absolute;
            width: 100%;
            max-width: 90%;
            left:5%;
            bottom: 70px;
          // position: relative;
          // width: 100%;
          // max-width: 90%;
          // display: block;
          // margin: -40px auto 0 auto;
          @media (max-width: 533px){
            max-width: 85%;
            left:7.5%;
            font-size:14px;
          }
            @media (max-width: 330px){
     
            font-size:12px;
          }
         }
      }
    }
  }

  // This needs to be behind the caption
  .tns-controls {
    z-index: 1;
    position: absolute;
    //width: 100%;
    bottom: 50%;
    left:$padding;
    right:$padding;
    margin-top:(53px) / -2;
    text-align: center;
    //padding: 10px;
    display: flex;
    justify-content: space-between;
    outline: none;

    button {

      $width:30px;
      $height:53px;

      background: white;
      color: black;
      outline: none;
      padding: 0;

      width: $width;// + $padding * 2;
      height: $height;// + $padding * 2;

      box-sizing: border-box;
      background: transparent center center no-repeat;
      background-size: cover;
      background-size:  $width / $height;

      text-indent: -30000px;

      &[disabled] {
        color: #999;
        visibility: hidden;
        opacity:0;
      }
    }

    button[data-controls="prev"] {
        background-image: url(../assets/prev-arrow.png);
    }
    button[data-controls="next"] {
        background-image: url(../assets/next-arrow.png);
    }
  }
}

.inline-image{
  max-width:100%;
  max-height:100%;
  height:auto;
  margin:auto;
}
</style>
